import { Input } from "@/components/ui/input";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useState, useEffect } from "react";

interface FormData {
  email: string;
  password: string;
  phone: string;
}

interface AuthFormInputsProps {
  formData: FormData;
  setFormData: (data: FormData) => void;
}

export const SignInFormInputs = ({
  formData,
  setFormData,
}: AuthFormInputsProps) => {
  const [passwordError, setPasswordError] = useState<string | null>(null);

  useEffect(() => {
    if (formData.password && formData.password.length < 6) {
      setPasswordError("Password must be at least 6 characters long");
    } else {
      setPasswordError(null);
    }
  }, [formData.password]);

  const handleChange = (field: keyof FormData) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  return (
    <div className="space-y-4">
      <Input
        type="email"
        placeholder="Email address"
        value={formData.email}
        onChange={handleChange("email")}
        required
        className="bg-primary border-secondary text-primary-foreground placeholder:text-muted-foreground"
      />
      <div className="space-y-2">
        <Input
          type="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange("password")}
          required
          className={`bg-primary border-secondary text-primary-foreground placeholder:text-muted-foreground ${
            passwordError ? "border-red-500" : ""
          }`}
        />
        {passwordError && (
          <Alert variant="destructive">
            <AlertDescription>{passwordError}</AlertDescription>
          </Alert>
        )}
      </div>
    </div>
  );
};
